// AICE 5-product catalog. Single source of truth for landing, product detail
// pages, demo form, footer links and dashboard cross-links.
//
// User-visible text (tagline, hero, bullets, blockers) lives in i18n under the
// `public` namespace, keyed by slug: public.products.<slug>.{tagline,hero,
// bullets,blockers}. This file holds only language-neutral structure.

import type { IconKey } from "./icons";

export type ProductSlug =
  | "secure"
  | "driver"
  | "delivery"
  | "clerk"
  | "border";

export interface Product {
  slug: ProductSlug;
  brand: string;
  shortName: string;
  icon: IconKey;
  tone: "indigo" | "amber" | "emerald" | "violet" | "rose";
  modules: string[];
  status: "live" | "beta" | "pilot";
}

export const PRODUCTS: Product[] = [
  {
    slug: "secure",
    brand: "AICE SECURE",
    shortName: "Secure",
    icon: "shield",
    tone: "indigo",
    modules: ["sentry_ai", "alarm_controller", "sync_manager"],
    status: "pilot",
  },
  {
    slug: "driver",
    brand: "AICE DRIVER",
    shortName: "Driver",
    icon: "eye",
    tone: "amber",
    modules: ["face_recognition", "digital_copilot", "obd_service"],
    status: "pilot",
  },
  {
    slug: "delivery",
    brand: "AICE DELIVERY",
    shortName: "Delivery",
    icon: "boxes",
    tone: "emerald",
    modules: ["smart_delivery", "notification-engine"],
    status: "beta",
  },
  {
    slug: "clerk",
    brand: "AICE CLERK",
    shortName: "Clerk",
    icon: "receipt",
    tone: "violet",
    modules: ["expense-service", "fuel-validator"],
    status: "beta",
  },
  {
    slug: "border",
    brand: "AICE BORDER",
    shortName: "Border",
    icon: "globe",
    tone: "rose",
    modules: ["sentry_ai", "report-service"],
    status: "pilot",
  },
];

export const PRODUCT_BY_SLUG: Record<ProductSlug, Product> = PRODUCTS.reduce(
  (acc, p) => {
    acc[p.slug] = p;
    return acc;
  },
  {} as Record<ProductSlug, Product>,
);
